import Parent from "parentjs/controllers/services_controller.js";
export default Parent;
